import { APIError } from '../errors/APIError';
import { useAPIMutation, useAPIQuery } from '../useAPIProvider';

interface CreateAddressArgs {
  name: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  country: string;
  postcode: string;
}

export const useCreateAddress = () => {
  return useAPIMutation(client => {
    return async ({ ...args }: CreateAddressArgs) => {
      const response = await client.address.postAddress({
        body: { ...args }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);
      return response.body;
    };
  });
};

export const useAddress = (id?: string) => {
  return useAPIQuery(['getAddress', id], async client => {
    if (!id) return null;
    const response = await client.address.getAddress({ params: { id } });
    if (response.status !== 200) throw APIError.fromResponse(response);
    return response.body;
  });
};

export const useDeleteAddress = () => {
  return useAPIMutation(client => async ({ id }: { id: string }) => {
    return await client.address.deleteContact({ params: { id } });
  });
};

interface UpdateAddressArgs extends CreateAddressArgs {
  id: string;
}

export const useUpdateAddress = () => {
  return useAPIMutation((client, query) => {
    return async ({ id, ...args }: UpdateAddressArgs) => {
      const response = await client.address.updateAddress({
        body: { ...args },
        params: {
          id
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);
      await query.invalidateQueries(['getAddress', id]);

      return response.body;
    };
  });
};
